<div class="dtf-accountdetails">

  <div class="container_dashboard" style="padding: 0px;">
        <div class="tile" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px; padding-right: 21px;">
        
          <a id="mbfs-header-login-cta" id="auto_triggerautopay" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickAutoPay($event)" hidden></a>

          <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
          </div>

          <div *ngIf="SelectAutopay">
            <form #form="ngForm" *ngIf="!this.bodyLoaded && (!SelectAutopaySignup && !SelectAutopayTerminate && !SelectAutopayEdit)">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="dtfbrochures__header_dark">Auto Pay</h4>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col">
                    <p>Auto Pay: IT'S THE SMART AND EASY WAY TO MAKE YOUR MONTHLY PAYMENTS.</p>
                    <p>Offered at no charge to Daimler Truck Financial Services USA LLC primary account holders, Auto Pay automatically deducts your monthly payment(s) from the bank account(s) you specify. Your payment is electronically deducted each month on your scheduled due date. If your due date happens to fall on a weekend or holiday, the deduction is processed on the next business date. And for your convenience, a record of the transaction is documented on your bank statement.</p>
                    <br>
                    <p>HOW DOES Auto Pay BENEFIT ME?</p>
                    <p>With Auto Pay, you'll never have to worry about lost checks, late payment fees or additional interest associated with missed payments. Auto Pay eliminates the need to write monthly checks and saves you the expense of postage. Auto Pay combines security and convenience, while giving you the peace of mind knowing that your payment is made on time, every time.</p>
                    <br>
                    <p>It's EASY! Auto Pay will automatically deduct your monthly payment from your specified bank account(s), starting on your next due date. To sign up immediately, just select the “Sign Up” option below, or for more information please call Customer Service at 800-222-4221 or Fleet Services at 877-294-9679. If you are already enrolled for Auto Pay and you want to update or change your existing information, please click on Edit/Change button below.</p>
                  </div>
                </div>
              </div>
              <br>
              <div class="example-button-row" style="justify-content: center;">
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedAutopayState" (change)="onChangeAutopayButton($event)">
                  <mat-button-toggle style="background-color: #00566A !important; color: white !important;"  *ngIf="isPC" [value]="toggleAutoPayEnum.Signup">Sign Up</mat-button-toggle>
                  <mat-button-toggle style="background-color: #00566A !important; color: white !important;"  *ngIf="isAP" [value]="toggleAutoPayEnum.Edit">Edit</mat-button-toggle>
                  <mat-button-toggle style="background-color: #00566A !important; color: white !important;"  *ngIf="isAP" [value]="toggleAutoPayEnum.Terminate">Terminate</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </form>
            <h4 class="dtfbrochures__header_dark" *ngIf="SelectAutopaySignup">Sign Up Auto Pay</h4>
            <h4 class="dtfbrochures__header_dark" *ngIf="SelectAutopayEdit">Edit Auto Pay</h4>
            <h4 class="dtfbrochures__header_dark" *ngIf="SelectAutopayTerminate">Terminate Auto Pay</h4>

            <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
              <!--Spinner on Login Load-->
              <div class="demo-container">
                <span>{{ 'Invoice.Loading' | translate }}</span>
                <div class="progress-bar">
                  <div class="progress-bar-value"></div>
                </div>
              </div>
              <br>
            </div>

            <div *ngIf="SelectAutopaySignup && !selectBankProfile">
              <div class="accountflex">
                <h1 class="mercedes-me-login__column-headline2"></h1>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                  <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                  <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>
              </div>
              <div class="row">
                <div class="col">
                  <p>Please select up to 10 accounts per transaction for Auto Pay sign up.</p>
                </div>
              </div>
              <!-- <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div> -->
              <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst"> 
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"  >
            </mat-checkbox></div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null"
                  [checked]="selection.isSelected(element)" >
              </mat-checkbox></div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
    
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="agreementDetailsList">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="agreementDetailsList === element"
              (click)="agreementDetailsList = agreementDetailsList === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['agreementDetailsList']" class="example-detail-row"></mat-row>
    
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
          </tr>
    
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="openAutoPayPopup()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>

            </div>
            <div *ngIf="SelectAutopaySignup && selectBankProfile">
              <form [formGroup]="bankProfileForm" *ngIf="openLoginModal">
                <div *ngIf="(selectBankProfile && !selectBankVerification)"> 
                  <div class="mbfs-modal-content">
                    <h5>{{ 'AutoPayModal.CreateBankProfile' | translate }}</h5>
                    <div class="mbfs-bank-profile-create-inner">
                      <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <b for="routingNumber">{{ 'AutoPayModal.RoutingNumber' | translate }} </b><br>
                              <div class="col">
                                <input class="form-control" type="text" maxlength="9" (change)="getRoutingNumber($event)" name="routingNumber" id="routingNumber"
                                  formControlName="routingNumber" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%; margin-left: 0%;">
                                
                                <div class="col-12">
                                  <b>{{ 'AutoPayModal.AccountType' | translate }}:</b>
                                </div>
                            
                                <div class="col-12 mt-2">
                                  <label class="me-3">
                                    <input type="radio" value="C" formControlName="AccountType">
                                    <span> Checking  &nbsp;</span>
                                  </label>
                            
                                  <label>
                                    <input type="radio" value="S" formControlName="AccountType">
                                    <span> Savings</span>
                                  </label>
                                </div>
                            
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <b for="bankName">{{ 'AutoPayModal.BankName' | translate }} </b><br>
                              <div class="col">
                                <input class="form-control" type="text" name="bankName" id="bankName"
                                  formControlName="bankName" [(ngModel)]="bankName" readonly required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="bankAccountNumber">{{ 'AutoPayModal.BankAccountNumber' | translate }}</b><br>
                              <div class="col">
                                <input class="form-control" [readonly]="!routingValid" type="text" maxlength="17" (change)="verifyAccountNumber($event)" name="bankAccountNumber" id="bankAccountNumber"
                                  formControlName="bankAccountNumber" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <b for="nameOnBankAccount">{{ 'AutoPayModal.NameOnBankAccount' | translate }} </b><br>
                              <div class="col">
                                <input class="form-control" type="text" maxlength="18" name="nameOnBankAccount" id="nameOnBankAccount"
                                  formControlName="nameOnBankAccount" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="bankAccountNumberConfirmation">{{ 'AutoPayModal.BankAccountNumberConfirmation' | translate }}</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [readonly]="!routingValid" maxlength="17" name="bankAccountNumberConfirmation" id="bankAccountNumberConfirmation"
                                  formControlName="bankAccountNumberConfirmation" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                                <span><b>{{ 'AutoPayModal.NoteBankAccount' | translate }}</b></span>
                            </div>
                            <div class="col-md-6">
                              <b for="ownerLeseeName">{{ 'AutoPayModal.OwnerLessee' | translate }}</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="ownerLeseeName" readonly name="ownerLeseeName" id="ownerLeseeName"
                                  formControlName="ownerLeseeName" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>  
                          <div class="row" style="margin-top: 0%;">
                            <div class="col-md-6">
                                <span><b>Auto Pay accounts will not recieve paper/digital statement(s) unless opted in.</b></span>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%;margin-left: 0%;">
                                <b for="AccountType">Do you want eBill/Digital Statements? : </b><br>
                                <div class="col" style="gap: 10%;">
                                  <label>
                                    <input type="radio" value="true" formControlName="AutopayType">
                                      <span>&nbsp;Yes&nbsp;</span>
                                  </label>
                                  <label>
                                    <input type="radio" value="false" formControlName="AutopayType">
                                      <span>&nbsp;No</span>
                                  </label>                            
                                </div>
                              </div>
                            </div>
                          </div><br>
                            <div class="listrow" *ngFor="let contract of contractNumberList; first as isFirst;">
                              <div class="listcolumn">
                                <h4 *ngIf="isFirst">Contract Number(s)</h4>
                                <p>{{contract.contractNumber}}</p>
                              </div>
                              <div class="listcolumn">
                                <h4 *ngIf="isFirst">Effective Date</h4>
                                <p>{{contract.effectiveDate}}</p>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="agentview !='true'">
                    <button type="submit" [disabled]="agentview==='true'" (click)="openBankWarning()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                    <button type="submit" [disabled]="agentview==='true'" (click)="backstep2signup()" class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>
                  </div>
                  <div *ngIf="agentview ==='true'">
                    <button type="submit" [disabled]="true" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                  </div>
              </div>
              <div *ngIf="(selectBankProfile && selectBankVerification)"> 
                <div class="mbfs-modal-content">
                  <h5>Confirm Bank Profile</h5>
                  <div class="mbfs-bank-profile-create-inner">
                    <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <b for="routingNumber">{{ 'AutoPayModal.RoutingNumber' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="9" readonly name="routingNumber" id="routingNumber"
                                formControlName="routingNumber" [(ngModel)]="routingNumber" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="ownerLeseeName">{{ 'AutoPayModal.OwnerLessee' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" readonly name="ownerLeseeName" id="ownerLeseeName"
                                formControlName="ownerLeseeName"  [(ngModel)]="ownerLeseeName" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <b for="bankName">{{ 'AutoPayModal.BankName' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" name="bankName" id="bankName"
                                formControlName="bankName" [(ngModel)]="bankName" readonly required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="bankAccountNumber">{{ 'AutoPayModal.BankAccountNumber' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="17" readonly name="bankAccountNumber" id="bankAccountNumber"
                                formControlName="bankAccountNumber"  [(ngModel)]="bankAccountNumber" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <b for="nameOnBankAccount">{{ 'AutoPayModal.NameOnBankAccount' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="18" readonly name="nameOnBankAccount" id="nameOnBankAccount"
                                formControlName="nameOnBankAccount"  [(ngModel)]="nameOnBankAccount" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="bankAccountNumberConfirmation">{{ 'AutoPayModal.BankAccountNumberConfirmation' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" readonly maxlength="17" name="bankAccountNumberConfirmation" id="bankAccountNumberConfirmation"
                                formControlName="bankAccountNumberConfirmation" [(ngModel)]="bankAccountNumberConfirmation" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>

                                                
                        <div class="row" style="margin-top: 0%;">
                          <div class="col-md-6">
                            <span><b>{{ 'AutoPayModal.NoteBankAccount' | translate }}</b></span>
                          </div>
                          <div class="col-md-6">
                            <b for="AccountType">{{ 'AutoPayModal.AccountType' | translate }} : {{DisplayAccountType}}</b><br>
                          </div>
                        </div>

                        <div class="row" style="margin-top: 0%;">
                          <div class="col-md-6">
                              <span><b>Auto Pay accounts will not recieve paper/digital statement(s) unless opted in.</b></span>
                          </div>
                          <div class="col-md-6">
                            <b for="AccountType">Do you want eBill/Digital Statements? : {{AutopayType}}</b><br>
                          </div>
                        </div>
                        <br>
                        <div class="listrow" *ngFor="let contract of contractNumberList; first as isFirst;">
                          <div class="listcolumn">
                            <h4 *ngIf="isFirst">Contract Number(s)</h4>
                            <p>{{contract.contractNumber}}</p>
                          </div>
                          <div class="listcolumn">
                            <h4 *ngIf="isFirst">Effective Date</h4>
                            <p>{{contract.effectiveDate}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="submit" [disabled]="!this.tableLoaded" (click)="onAutoPaySignUpSubmit()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              </div>
              </form>
            </div>

            <div *ngIf="SelectAutopayEdit && !selectBankProfile">
              <div class="accountflex">
                <h1 class="mercedes-me-login__column-headline2"></h1>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                  <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                  <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>
              </div>
              <div class="row">
                <div class="col">
                  <p>Please select up to 1 account per transaction for Auto Pay Edit.</p>
                </div>
              </div>
              <!-- <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div> -->
              <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst"> 
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                [checked]="selectionsingle.hasValue() && isAllSelected()"
                [indeterminate]="selectionsingle.hasValue() && !isAllSelected()"  >
            </mat-checkbox></div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selectionsingle.toggle(element) : null"
                  [checked]="selectionsingle.isSelected(element)" >
                  
              </mat-checkbox></div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
    
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="agreementDetailsList">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="agreementDetailsList === element"
              (click)="agreementDetailsList = agreementDetailsList === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['agreementDetailsList']" class="example-detail-row"></mat-row>
    
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
          </tr>
    
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="openAutoPayEdit()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>

            </div>
            <div *ngIf="SelectAutopayEdit && selectBankProfile">
              <form [formGroup]="bankProfileForm" *ngIf="openLoginModal">
              <div *ngIf="(selectBankProfile && selectBankVerification)"> 
                <div class="mbfs-modal-content">
                  <h5>{{ 'AutoPayModal.UpdateBankProfile' | translate }}</h5>
                  <div class="mbfs-bank-profile-create-inner">
                    <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6">
                            <b for="routingNumber">{{ 'AutoPayModal.RoutingNumber' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="9" name="routingNumber" id="routingNumber"
                                formControlName="routingNumber" (change)="getRoutingNumber($event)" [(ngModel)]="routingNumber" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="ownerLeseeName">{{ 'AutoPayModal.OwnerLessee' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" [(ngModel)]="ownerLeseeName" readonly name="ownerLeseeName" id="ownerLeseeName"
                                formControlName="ownerLeseeName" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <b for="bankName">{{ 'AutoPayModal.BankName' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" name="bankName" id="bankName"
                                formControlName="bankName" [(ngModel)]="bankName" readonly required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="bankAccountNumber">{{ 'AutoPayModal.BankAccountNumber' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="17" name="bankAccountNumber" id="bankAccountNumber"
                                formControlName="bankAccountNumber"  (change)="verifyAccountNumber($event)" [(ngModel)]="bankAccountNumber" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <b for="nameOnBankAccount">{{ 'AutoPayModal.NameOnBankAccount' | translate }} </b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="18" name="nameOnBankAccount" id="nameOnBankAccount"
                                formControlName="nameOnBankAccount"  [(ngModel)]="nameOnBankAccount" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <b for="bankAccountNumberConfirmation">{{ 'AutoPayModal.BankAccountNumberConfirmation' | translate }}</b><br>
                            <div class="col">
                              <input class="form-control" type="text" maxlength="17" name="bankAccountNumberConfirmation" id="bankAccountNumberConfirmation"
                                formControlName="bankAccountNumberConfirmation" [(ngModel)]="bankAccountNumberConfirmation" required validateonblur value="" autocomplete="off">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <span><b>{{ 'AutoPayModal.NoteBankAccount' | translate }}</b></span>
                          </div>
                          <div class="col-md-6">
                            <div class="row" style="margin-top: 0%; margin-left: 0%;">
                              <b for="AccountType">{{ 'AutoPayModal.AccountType' | translate }}: </b><br>
                              <div class="col" style="gap: 10%;">
                                <label>
                                  <input type="radio" value="CONSUMER_CHECKING" [(ngModel)]="AccountType" formControlName="AccountType">
                                    <span>&nbsp;Checking&nbsp;</span>
                                </label>
                                <label>
                                  <input type="radio" value="CONSUMER_SAVINGS" [(ngModel)]="AccountType" formControlName="AccountType">
                                    <span>&nbsp;Savings</span>
                                </label>  
                              </div>
                              </div>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 0%;">
                          <div class="col-md-6">
                            <span><b>Auto Pay accounts will not recieve paper/digital statement(s) unless opted in.</b></span>
                          </div>
                          <div class="col-md-6">
                            <b for="AccountType">Do you want eBill/Digital Statements? : {{displaypymtOption}}</b><br>
                          </div>
                        </div><br>
                        <div class="listrow" *ngFor="let contract of contractNumberList; first as isFirst;">
                          <div class="listcolumn">
                            <h4 *ngIf="isFirst">Contract Number(s)</h4>
                            <p>{{contract.contractNumber}}</p>
                          </div>
                          <div class="listcolumn">
                            <h4 *ngIf="isFirst">Effective Date</h4>
                            <p>{{contract.effectiveDate}}</p>
                          </div>
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="agentview !='true'">
                  <button type="submit" [disabled]="(!this.tableLoaded && agentview==='true')" (click)="editValidations()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                  <button type="submit" class="mbfs-button" (click)="backstep2edit()">{{ 'LoginModal.back' | translate }}</button>
                </div>
                <div *ngIf="agentview ==='true'">
                  <button type="submit" [disabled]="true" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                </div>
              </div>
              </form>
            </div>

            <div *ngIf="SelectAutopayTerminate && !selectBankProfile">
              <div class="accountflex">
                <h1 class="mercedes-me-login__column-headline2"></h1>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                  <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                  <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>
              </div>
              <div class="row">
                <div class="col">
                  <p> Please select up to 10 accounts per transaction you want to terminate from Auto Pay services.</p>
                </div>
              </div>
              <!-- <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div> -->
              <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst"> 
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"  >
            </mat-checkbox></div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null"
                  [checked]="selection.isSelected(element)" >
              </mat-checkbox></div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
    
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="agreementDetailsList">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="agreementDetailsList === element"
              (click)="agreementDetailsList = agreementDetailsList === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['agreementDetailsList']" class="example-detail-row"></mat-row>
    
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
          </tr>
    
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="openAutoPayTerminate()" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>

            </div>
            <div *ngIf="SelectAutopayTerminate && selectTerminate">
              <p>You may discontinue Auto Pay withdrawals at any time. If you elect to cancel this authorization, you may do so completing the termination request below or by calling Customer Service at 800-222-4221 or Fleet Services at 877-294-9679. Terminations will be effective within five business days of your request.</p><br>

              <p><b>Account Name: </b> {{customerName}}</p>
              <p><b>{{ 'Payoff.AccountNumbers' | translate }}</b> {{this.displaycontractNumberList}}</p>

              <div *ngIf="agentview !='true'">
                <button type="submit" [disabled]="!this.tableLoaded" (click)="this.openDialog(6)" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep2terminate()" class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>

              </div>
              <div *ngIf="agentview ==='true'">
                <button type="submit" [disabled]="true" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              </div>
            </div>

          </div>
        </div>

  </div>



</div>